"use strict";

angular.module('app.shared.services')
	.factory("localizationService", localizationService);

localizationService.$inject = ['$q', 'httpRequest', 'appGlobals', 'sessionService'];

function localizationService($q, httpRequest, appGlobals, sessionService) {
	var baseurl = appGlobals.baseApiUrl;
	var url = "";
	var localStrings = null;
	var localStringDictionary = {};

	var task;
	var module;
	var userLocale;
	var browserLocale;
	var localeLoaded = false;

	var setLocalStrings = function (data) {
		localStrings = data;
	};

	var setTask = function (taskKey) {
		task = taskKey;
		isModule = false;
	};

	var getTask = function () {
		return task;
	};

	var setModule = function (moduleKey) {
		module = moduleKey;
		isModule = true;
	};

	var getModule = function () {
		return module;
	};

	var getLocalString = function (stringNum, datasource) {

		//var iMin;
		//var iMax;
		//var iMidPoint;

		var stringText = localStringDictionary[stringNum];

		return (stringText) ? stringText : "String Not Found";

		//if (datasource) {
		//    iMax = datasource.length - 1;
		//    iMin = 0;

		//    var count = 0;

		//    //Let's Binary Search
		//    while (iMax >= iMin) {

		//        //find midpoint
		//        iMidPoint = Math.floor(iMin + ((iMax - iMin) / 2));

		//        //Is this the String
		//        if (datasource[iMidPoint].StringNum == stringNum) {
		//            return datasource[iMidPoint].LocalText;
		//        } else if (datasource[iMidPoint].StringNum < stringNum) {
		//            iMin = iMidPoint + 1; //Search Upper Array
		//        } else
		//            iMax = iMidPoint - 1; //Search Lower Array
		//    }

		//    return 'String Not Found.'
		//}
	};

	//jQuery wrapper to call this outside of an Angular Controller

	var getLocalStringDB = function (stringNum, successCallback, errorCallback) {
		var url = baseurl + "localizations/GetLocalString/" + userLocale.LangID + '/' + stringNum;
		return httpRequest.doGetRequest(url);
	};

	var getPreferredaSaLocale = function () {
		return $q(function (resolve, reject) {
			if (localeLoaded == false) {
				//var url = baseurl + "locales/GetPreferredaSaLocale";
				var currentUser = sessionService.getCurrentUser();
				var url = baseurl + "locales/getUserLocale/" + currentUser.LangID;
				httpRequest.doGetRequest(url, null).then(function (localeData) {
					browserLocale = localeData.BrowserLocale;
					userLocale = localeData.UserLocale;
					localeLoaded = true;
					resolve(localeData);
				});
			}
			else {
				resolve({ UserLocale: userLocale, BrowserLocale: browserLocale });
			}
		});
	};

	var getLocale = function (locale) {
		url = baseurl + "locales/'" + locale + "'";
		return httpRequest.doGetRequest(url)
	};

	var getTaskLocalStrings = function (taskKey, langid) {
		var url = baseurl + "localizations/GetTaskLocalStrings/" + langid + '/' + taskKey;
		return httpRequest.doGetRequest(url)
	};

	var getTasksLocalStrings = function (list, langid) {
		var url = baseurl + "localizations/GetTasksLocalStrings?langID=" + langid + "&taskList=" + list;
		return httpRequest.doGetRequest(url)
	};

	var getModuleLocalStrings = function (moduleKey, langid) {
		var url = baseurl + "localizations/GetModuleLocalStrings/" + langid + '/' + moduleKey;
		return httpRequest.doGetRequest(url)
	};

	var getTaskBrowserLocalStrings = function (taskKey) {
		var url = baseurl + "localizations/getTaskBrowserLocalStrings/" + taskKey;
		return httpRequest.doGetRequest(url)
	};


	var localizeTask = function (task) {
		console.log("localizeTask");
		//ANG 1.6 CHANGE 
		return $q(function (resolve, reject) {

			var currTask = getTask();
			if (currTask == task && localStrings != null) {
				resolve(localStrings);
				return;
			}

			setTask(task);
			localStrings = null;

			getPreferredaSaLocale().then(function (data) {
				//Globalize.culture(data.LocaleID.toLowerCase());
				var langID = data.UserLocale.LangID;
				getTaskLocalStrings(task, langID).then(function (taskData) {
					localStrings = taskData;
					populateLocalStringDictionary(localStrings);
					resolve(localStrings);
				});
			});

		});

	};

	var localizeTaskList = function (taskList) {

		//ANG 1.6 CHANGE 
		return $q(function (resolve, reject) {

			setTask(null);
			localStrings = null;

			getPreferredaSaLocale().then(function (data) {
				//Globalize.culture(data.LocaleID);
				var langID = data.UserLocale.LangID;
				getTasksLocalStrings(taskList, langID).then(function (taskData) {
					localStrings = taskData;
					populateLocalStringDictionary(localStrings);
					resolve(localStrings);
				});
			});
		});

	};

	var localizeModule = function (module) {
		var currModule = getModule();
		if (currModule == module && localStrings != null) return $q.when();

		setModule(module);
		localStrings = null;

		var langIDPromise = getPreferredaSaLocale();
		var localStringsPromise = langIDPromise.then(function (data) {
			//Globalize.culture(data.LocaleID.toLowerCase());
			var langID = data.UserLocale.LangID;
			return getModuleLocalStrings(module, data.LangID).then(function (taskData) {
				localStrings = taskData.data;
				populateLocalStringDictionary(localStrings);
			});
		});

		return localStringsPromise;
	};

	//WILL KEEP A RUNNING DICTIONARY OF USED LOCAL STRINGS
	var populateLocalStringDictionary = function (localStrings) {
		var iCount = localStrings.length;
		for (var i = 0; i < iCount; i++) {
			localStringDictionary[localStrings[i].StringNum] = localStrings[i].LocalText;
		}
	};

	function getPreferredCurrencies(preferredLocales) {
		if (preferredLocales == null) { preferredLocales = []; }
		var preferredCurrencies = [];
		for (var i = 0; i < preferredLocales.length; i++) {
			var preferredLocale = preferredLocales[i];
			var matchIdx = indexOfExisting(preferredCurrencies, "CurrencyID", preferredLocale.Locale.Currency.CurrencyID);
			if (matchIdx == null) {
				var preferredCurrency = preferredLocale.Locale.Currency;
				preferredCurrency.Inactive = preferredLocale.Inactive;
				preferredCurrencies.push(preferredCurrency);
			}
		}
		return preferredCurrencies;
	};

	function setLocalizedPropertyOnArray(array, property) {
		if (array == null) { return; }
		for (var i = 0; i < array.length; i++) {
			array[i][property] = getLocalString(array[i].StringNum);
		}
	};

	return {
		getLangID: function () { return (userLocale != null) ? userLocale.LangID : null; },
		getLocaleID: function () { return (userLocale != null) ? userLocale.LocaleID : null; },
		getPreferredaSaLocale: getPreferredaSaLocale,
		getLocale: getLocale,
		getLocalStrings: function () { return localStrings; },
		setLocalStrings: setLocalStrings,
		getLocalStringDB: getLocalStringDB,
		getLocalString: getLocalString,
		getTaskLocalStrings: getTaskLocalStrings,
		getTasksLocalStrings: getTasksLocalStrings,
		getTaskBrowserLocalStrings: getTaskBrowserLocalStrings,
		localizeTask: localizeTask,
		localizeTaskList: localizeTaskList,
		localizeModule: localizeModule,
		populateLocalStringDictionary: populateLocalStringDictionary,
		getPreferredCurrencies: getPreferredCurrencies,
		setLocalizedPropertyOnArray: setLocalizedPropertyOnArray
	};
}